import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from "aos"
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';
import { GlobalConstants } from './common/global-constants';

declare const gtag: Function;
declare const ga: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'retailco.es';

  constructor(private readonly router: Router,
    private titleService: Title) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', GlobalConstants.googleGTAG, { 'page_path': event.urlAfterRedirects });
      }
    });
  }

  ngOnInit(): void {
    AOS.init();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(`${title}`);
        }
      });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }

  ngAfterViewInit(): void {

  }
}
